import { lazy } from "react";

export const NewCouponPage = lazy(() => import("./newCouponPage"));
